import { render, staticRenderFns } from "./Ready4k.vue?vue&type=template&id=44f04b40&scoped=true&"
import script from "./Ready4k.vue?vue&type=script&lang=ts&"
export * from "./Ready4k.vue?vue&type=script&lang=ts&"
import style0 from "./Ready4k.vue?vue&type=style&index=0&id=44f04b40&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f04b40",
  null
  
)

export default component.exports